/* Novicell responsive
*  Author: APN, modified by MMA, LHE, TBB & DLA
*  Use JS to detect current breakpoint from CSS
* ------
* Dependencies: Modernizr
* Required less:
* // Set body classes for responsive script
*    body:after {content: "media-lg"; visibility: hidden; position: absolute; left: -999999px; bottom: 0; speak:none;
*       @media screen and (max-width: @screen-sm) {& { content: "media-xs"; }}
*       @media screen and (min-width: @screen-sm)and (max-width: @screen-md) {& { content: "media-sm"; }}
*       @media screen and (min-width: @screen-md)and (max-width: @screen-lg) {& { content: "media-md"; }}
*       @media screen and (min-width: @screen-lg) {& { content: "media-lg"; }}
*   }
* Usage:
*   Get the mode:
*       novicell.responsive.getMode();
*   As a helper:
*       if(novicell.responsive.isXs){ //do stuff };
* Initialize:
*   novicell.responsive.init(callback);
* Extend:
*   novicell.responsive.aboveSm = function(){
*        return novicell.responsive.getMode() == 'media-md' || novicell.responsive.getMode() == 'media-lg' ? true : false;
*   };
*
*/

/* Modernizr 2.8.3 (Custom Build) | MIT & BSD
 * Build: http://modernizr.com/download/#-mq-teststyles
 */
;window.Modernizr=function(a,b,c){function v(a){i.cssText=a}function w(a,b){return v(prefixes.join(a+";")+(b||""))}function x(a,b){return typeof a===b}function y(a,b){return!!~(""+a).indexOf(b)}function z(a,b,d){for(var e in a){var f=b[a[e]];if(f!==c)return d===!1?a[e]:x(f,"function")?f.bind(d||b):f}return!1}var d="2.8.3",e={},f=b.documentElement,g="modernizr",h=b.createElement(g),i=h.style,j,k={}.toString,l={},m={},n={},o=[],p=o.slice,q,r=function(a,c,d,e){var h,i,j,k,l=b.createElement("div"),m=b.body,n=m||b.createElement("body");if(parseInt(d,10))while(d--)j=b.createElement("div"),j.id=e?e[d]:g+(d+1),l.appendChild(j);return h=["&#173;",'<style id="s',g,'">',a,"</style>"].join(""),l.id=g,(m?l:n).innerHTML+=h,n.appendChild(l),m||(n.style.background="",n.style.overflow="hidden",k=f.style.overflow,f.style.overflow="hidden",f.appendChild(n)),i=c(l,a),m?l.parentNode.removeChild(l):(n.parentNode.removeChild(n),f.style.overflow=k),!!i},s=function(b){var c=a.matchMedia||a.msMatchMedia;if(c)return c(b)&&c(b).matches||!1;var d;return r("@media "+b+" { #"+g+" { position: absolute; } }",function(b){d=(a.getComputedStyle?getComputedStyle(b,null):b.currentStyle)["position"]=="absolute"}),d},t={}.hasOwnProperty,u;!x(t,"undefined")&&!x(t.call,"undefined")?u=function(a,b){return t.call(a,b)}:u=function(a,b){return b in a&&x(a.constructor.prototype[b],"undefined")},Function.prototype.bind||(Function.prototype.bind=function(b){var c=this;if(typeof c!="function")throw new TypeError;var d=p.call(arguments,1),e=function(){if(this instanceof e){var a=function(){};a.prototype=c.prototype;var f=new a,g=c.apply(f,d.concat(p.call(arguments)));return Object(g)===g?g:f}return c.apply(b,d.concat(p.call(arguments)))};return e});for(var A in l)u(l,A)&&(q=A.toLowerCase(),e[q]=l[A](),o.push((e[q]?"":"no-")+q));return e.addTest=function(a,b){if(typeof a=="object")for(var d in a)u(a,d)&&e.addTest(d,a[d]);else{a=a.toLowerCase();if(e[a]!==c)return e;b=typeof b=="function"?b():b,typeof enableClasses!="undefined"&&enableClasses&&(f.className+=" "+(b?"":"no-")+a),e[a]=b}return e},v(""),h=j=null,e._version=d,e.mq=s,e.testStyles=r,e}(this,this.document);

var novicell = novicell || {};

novicell.responsive = new function () {
    var self = this;
    var responsiveMode = 'media-lg';

    this.getMode = function () {
        if (Modernizr.mq('(min-width: 0px)') && window.getComputedStyle != undefined) {
            var responsiveMode = window.getComputedStyle(document.body, ':after').getPropertyValue('content');
            self.responsiveMode = responsiveMode.replace(/['"]/g, ''); //for firefox and chrome
            return self.responsiveMode;
        } else {
            return responsiveMode;
        }
    };

    this.init = function (callback) {
        if (Modernizr.mq('(min-width: 0px)') && window.getComputedStyle != undefined) {
            self.setMode(callback);
            //TODO: add resize debouncer
            $(window).resize(function () {
                self.setMode(callback);
            })
            .bind('orientationchange', function () {
                $(window).resize();
            });

            return self;
        }
    };

    this.setMode = function (callback) {
        var responsiveMode = self.getMode();

        return self;
    };

    // Set helpers
    this.isXs = function(){
        return self.getMode() == 'media-xs' ? true : false;
    };
    this.isSm = function(){
        return self.getMode() == 'media-sm' ? true : false;
    };
    this.isMd = function(){
        return self.getMode() == 'media-md' ? true : false;
    };
    this.isLg = function(){
        return self.getMode() == 'media-lg' ? true : false;
    };
}